module.exports = __webpack_public_path__ + "static/media/negative.41c457d6.svg";